import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import styles from './PageErrorFallback.module.scss';
import { Props } from './PageErrorFallback.types';

const PageErrorFallback = ({ resetError }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { assetId } = useParams<{ assetId: string }>();

  const goHome = () => {
    resetError();
    if (assetId) {
      navigate(`/asset/${assetId}/dashboard`);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {t('error.somethingWentWrong', ' ⚠️Oups, une erreur est survenue !')}
      </h2>
      <p className={styles.description}>
        {t(
          'error.description',
          'Notre équipe a été prévenue. Vous pouvez réessayer ou revenir à l’accueil.'
        )}
      </p>
      <div className={styles.actions}>
        <Button size="md" onClick={resetError}>
          {t('error.retry', 'Réessayer')}
        </Button>
        <Button size="md" variant="outline" onClick={goHome}>
          {t('error.backHome', 'Retour à l’accueil')}
        </Button>
      </div>
    </div>
  );
};

export default PageErrorFallback;
